// extracted by mini-css-extract-plugin
export default {"picture":"Picture_picture__asf3T","picture_small":"Picture_picture_small__sjKY8","picture_large":"Picture_picture_large__Fb4O-","picture_xlarge":"Picture_picture_xlarge__0eQQg"};